import React from 'react'



const Footer = () => {
  return (
    <footer>
      <p>© 2022 | Designed & coded by <span>Wais Nazari</span> </p>

    </footer>
  )
}

export default Footer